export class CanaisComunicacaoWhatsAppChatImagem {
  public imageUrl: string;
  public thumbnailUrl: string;
  public caption: string;
  public mimeType: string;
  public viewOnce: boolean;

  constructor() { }
}
